<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<section class="example-section">
  <mat-progress-bar class="example-margin" [color]="color" [mode]="mode" [value]="progresBarValue"
    [bufferValue]="bufferValue">
  </mat-progress-bar>
</section>
<div class="container design-overview-wrapper">
  <form focusInvalidInput class="form" (ngSubmit)="locationForm.form.valid && save()" #locationForm="ngForm">
    <h2> New Location</h2>
    <hr>
    <div class="breadcrumb">
      <ul class="d-flex align-items-center breadcrumb__list">
        <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
        </li>
        <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link">
            New Location</a>
        </li>
      </ul>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Subdivision Name <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="location.subdivision_name" (blur)="validateInputs()"
              name="subdivision_name" [ngModelOptions]="{standalone: false}" class="example-right-align"
              placeholder="Subdivision Name" #subdivision_name="ngModel" required>
          </mat-form-field>
          <mat-error *ngIf="locationForm.submitted && subdivision_name.errors?.required"> Subdivision Name Is Required
          </mat-error>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Lot <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="location.lot" (blur)="validateInputs()" name="lot"
              [ngModelOptions]="{standalone: false}" class="example-right-align" placeholder="Lot" #lot="ngModel"
              required>
          </mat-form-field>
          <mat-error *ngIf="locationForm.submitted && lot.errors?.required"> lot Is Required
          </mat-error>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Street_Address <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="location.street_address" (blur)="validateInputs()"
              name="equipmentname" [ngModelOptions]="{standalone: false}" class="example-right-align"
              placeholder="Street Address" #equipmentname="ngModel" required>
          </mat-form-field>
          <mat-error *ngIf="locationForm.submitted && equipmentname.errors?.required"> Street Address Is Required
          </mat-error>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">City <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="location.city" (blur)="validateInputs()" name="City"
              [ngModelOptions]="{standalone: false}" class="example-right-align" placeholder="City" #City="ngModel"
              required>
          </mat-form-field>
          <mat-error *ngIf="locationForm.submitted && City.errors?.required"> City Is Required
          </mat-error>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">State <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="text" [(ngModel)]="location.state" maxlength="3" (blur)="validateInputs()" name="State"
              [ngModelOptions]="{standalone: false}" class="example-right-align" placeholder="State" #State="ngModel"
              required>
          </mat-form-field>
          <mat-error *ngIf="locationForm.submitted && State.errors?.required"> State Is Required
          </mat-error>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex flex-wrap row">
        <div class="d-flex mb-3 col-md-6 flex-column px-3">

          <div class="ps-3">
            <p class="design-overview-wrapper__item__title">Zip <i style="color:red;">*</i></p>
          </div>

          <mat-form-field appearance="fill" floatLabel="always">
            <input matInput type="number" [(ngModel)]="location.zip" (blur)="validateInputs()" name="Zip"
              [ngModelOptions]="{standalone: false}" class="example-right-align" placeholder="Zip" #Zip="ngModel"
              required>
          </mat-form-field>
          <mat-error *ngIf="locationForm.submitted && Zip.errors?.required"> Zip Is Required
          </mat-error>
        </div>
      </div>
    </div>


    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title" style="color:red;">* Required fields
          </p>
        </div>
      </div>
    </div>


    <div class="design-overview-wrapper__item">
      <div class="d-flex my-3">
        <button mat-flat-button color="primary">Save</button>
      </div>
    </div>
  </form>
</div>
<div>

</div>